
function updateShopifyCart(
  action,
  designType,
  id,
  closetName = null,
  shopifyImage = null,
  awsImage = null,
  items = [],
  draftOrder = false
) {
  const baseUrl = "/cart";
  console.log("------ Update Shopify Cart ------");
  console.log({
    action,
    designType,
    id,
    closetName,
    shopifyImage,
    awsImage,
    items,
    draftOrder,
  });

  // Helper function to add items to the cart with line item properties
  function addToCart(items) {
    console.log("Add to Cart Items:", items);
    const _designName = closetName || id;

    let bundleName = `${designType} Design - ${_designName}`;
    let designUrl = `https://modularclosets.com/collections/milano?designId=${id}#configurator`;

    if (designType === "17Squares") {
      bundleName = `Custom Closet Design - ${_designName}`;
      designUrl = `https://modularclosets.com/pages/closet-design-tool?designId=${id}`;
      updateUtmContent("17Squares");
    }

    if (designType === "designTool") {
      bundleName = `Custom Closet Design - ${_designName}`;
      designUrl = `https://modularclosets.com/pages/design-tool?design-id=${id}`;
    }

    const payload = items.map((item) => ({
      id: item.id,
      quantity: item.quantity,
      properties: {
        _designId: id,
        _shopifyImage: shopifyImage,
        _awsImage: awsImage,
        _designImage: shopifyImage, //TODO remove from extension and stick with _shopifyImage
        _designType: designType, // Use the variable
        _designUrl: designUrl,
        _designName: _designName, // Use the variable
        // _bundleName: `${designType} Design - ${_designName}`, // Properly constructed string
        _bundleName: bundleName,
      },
    }));

    fetch(`${baseUrl}/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: payload }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Success:", data);
        if (window.location.pathname === "/cart") {
          if (window.theme && window.theme.mini_cart) {
            window.theme.mini_cart._updateMinicartData(1);
          }
          window.location.reload();
        } else {
          if (window.theme && window.theme.mini_cart) {
            let quantity = window.theme.cart.getCartQuantity();
            if (quantity == 0) {
              setTimeout(() => {
                console.log("Quantity is still zero, waiting .5 second...");
              }, 500);
            }
          } else {
            console.error("Mini cart component is not initialized.");
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        window.theme.mini_cart._updateMinicartData(1);
        window.theme.mini_cart._openMinicart(1, true);
      });
  }

  // Function to edit cart items based on the item title
  function editCartItem(items) {
    console.log("Edit Cart Items:", items);
    fetch(`${baseUrl}.js`)
      .then((response) => response.json())
      .then((cart) => {
        let targetItemIndex;
        if (designType === "17Squares" || designType === "designTool") {
          targetItemIndex = cart.items.findIndex(
            (item) =>
              item.properties && item.properties._designName === closetName
          );
        } else if (designType === "Milano") {
          targetItemIndex = cart.items.findIndex(
            (item) => item.properties && item.properties.designId === id
          );
        } else {
          console.error("Invalid designType", designType);
        }

        if (targetItemIndex !== -1) {
          // Remove the item by setting its quantity to 0
          fetch(`${baseUrl}/change.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: cart.items[targetItemIndex].key,
              quantity: 0,
            }),
          })
            .then((response) => response.json())
            .then(() => {
              // After removing, add the new list of items
              addToCart(items);
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        } else {
          console.error("Item not found in cart");
          addToCart(items);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  async function createDraft(email = null, items, discount = 0) {
    const _designType = "Milano";
    const _designName = closetName || id;
    let designUrl = `https://modularclosets.com/collections/milano?designId=${id}#configurator`;

    const payload = items.map((item) => ({
      id: item.id,
      quantity: item.quantity,
      properties: {
        _designId: id,
        // _shopifyImage: shopifyImage,
        // _awsImage: awsImage,
        // _designImage: shopifyImage,
        // _designType: _designType,
        // _designName: _designName,
        // _bundleName: `${_designType} Design - ${_designName}`,
        // designType: _designType,
        Design_Url: designUrl,
        Design: `${_designType} Design - ${_designName}`,
        Image: shopifyImage,
      },
    }));
    try {
      const response = await fetch(
        "https://modular-bundles--development.gadget.app/reps/createDraft",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            items: payload,
            discount: discount,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        console.log("Draft created successfully:", data);
        const invoiceUrl = data.invoiceUrl;
        const invoiceId = data.invoiceId.split("/").pop(); // Extracting the numeric ID from the gid

        // Update the invoice result section
        document.getElementById(
          "invoice-url"
        ).innerHTML = `Invoice URL: <a href="${invoiceUrl}" target="_blank">${invoiceUrl}</a>`;
        document.getElementById(
          "invoice-link"
        ).innerHTML = `Admin Dashboard: <a href="https://modularclosets.com/admin/draft_orders/${invoiceId}" target="_blank">View Invoice in Admin Dashboard</a>`;

        // Display the copy URL button
        const copyButton = document.getElementById("copy-url-btn");
        copyButton.style.display = "block";
        copyButton.onclick = function () {
          navigator.clipboard.writeText(invoiceUrl).then(
            function () {
              alert("URL copied to clipboard!");
            },
            function () {
              alert("Failed to copy URL.");
            }
          );
        };
        return data.draftUrl; // Returning the URL to the newly created Shopify draft order
      } else {
        throw new Error(data.message || "Failed to create draft order");
      }
    } catch (error) {
      console.error("Error creating draft:", error);
      throw error;
    }
  }

  // Determine action to perform
  if (draftOrder) {
    console.log("Draft order action triggered");
    const emailInput = document.getElementById("rep-email");
    console.log("emailInput:", emailInput);
    const email = emailInput.value || "";

    const discountInput = document.querySelector(".discount-percent input");
    console.log("discountInput:", discountInput);
    const discountValue = parseFloat(discountInput.value) || 0; // Ensure the discount is a number

    createDraft(email, items, discountValue);
    return;
  }
  if (action === "add") {
    addToCart(items);
  } else if (action === "edit") {
    editCartItem(items);
  } else if (action === "createDraft") {
    // let email ="jay@strongerecommerce.com"
    // createDraft(email, items);
  } else {
    console.error("Invalid action specified");
  }
}

function reconstructJsonFromUrlAndClearParams() {
  console.log("Start parsing json paramas:", window.location.href);
  const queryString = window.location.search.substring(1); // Remove '?' prefix
  const pairs = queryString
    .split("&")
    .map((pair) => pair.split("=").map(decodeURIComponent));

  let result = {};
  pairs.forEach(([key, value]) => {
    // Convert "flat" keys into a path array (e.g., 'designInfo[designID]' => ['designInfo', 'designID'])
    let path = key.split("[").map((part) => part.replace(/]$/, ""));
    let last = path.pop();
    let lastObj = path.reduce(
      (acc, cur) => (acc[cur] = acc[cur] || {}),
      result
    );
    lastObj[last] = value;
  });

  // Optionally, clear the URL parameters
  window.history.replaceState(null, "", window.location.pathname);

  addToCartWithDesignInfo(result);

  console.log("End parsing json paramas");

  return result;
}

// Check if the current page is /cart
if (window.location.pathname === "/cart") {
  // Call the function on page load to reconstruct the JSON object
  const reconstructedJson = reconstructJsonFromUrlAndClearParams();
  console.log(reconstructedJson);
  // window.location.reload();
}

var receiveMessage = function (event) {
  // console.log("Received event " + JSON.stringify(event));
  // Handle 'addToCart' messages
  if (event.data.type === "addToCart") {
    console.log("Message received:", event.data);
    console.log("Message Type:", event.data.type);
    const baseUrl = "https://modularclosets.com/cart";

    addToCartWithDesignInfo(event.data.payload);
  }
};
if (window.location.pathname === "/pages/closet-design-tool" || window.location.pathname === "/pages/design-tool") {
  window.addEventListener("message", receiveMessage, true);
}

function addToCartWithDesignInfo(cartData) {
  // Extract design info and items from the cartData
  let { designInfo, items } = cartData;

  if (!items || typeof items !== "object") {
    console.log("Invalid or missing cart data.");
    return; // Exit the function early if cartData is not an object
  }

  items = Object.entries(items).map(([id, quantity]) => ({
    id,
    quantity,
  }));

  console.log("designInfo:", designInfo);
  console.log("items:", items);

  // Check if the items array is empty, and return early if it is
  if (Object.keys(items).length === 0) {
    console.log("No items to add to cart.");
    return; // Exit the function early
  }

  // let shopifyImage =
  //   "https://cdn.shopify.com/s/files/1/0857/4644/files/closetImage_105.png";
  let shopifyImage =
    "https://cdn.shopify.com/s/files/1/0857/4644/files/IMG_5276.png?v=1713296290";
  // let awsImage =
  //   "https://modular-closet-configurator.s3.amazonaws.com/closet-design-images/closetImage_105.png";
  let awsImage =
    "https://cdn.shopify.com/s/files/1/0857/4644/files/IMG_5276.png?v=1713296290";

  updateShopifyCart(
    "edit",
    designInfo.designType,
    designInfo.designID,
    designInfo.designName,
    shopifyImage,
    awsImage,
    items
  );
}

// Function to get a cookie's value
function getCookie(name) {
  let value = "; " + document.cookie;
  let parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
  return null;
}

// Function to set or update the _shopify_sa_p cookie for utm_content only
function updateUtmContent(variable) {
  const cookieName = "_shopify_sa_p";
  let cookieValue = getCookie(cookieName) || "";
  let newValue = "utm_content=" + encodeURIComponent(variable);

  // Find and replace utm_content in the existing cookie value
  if (cookieValue.includes("utm_content=")) {
    let regex = /utm_content=[^&;]*/;
    cookieValue = cookieValue.replace(regex, newValue);
  } else {
    // Append new utm_content if it doesn't exist
    cookieValue += (cookieValue ? "&" : "") + newValue;
  }

  // Set the cookie with updated value
  document.cookie =
    cookieName +
    "=" +
    cookieValue +
    "; path=/; expires=" +
    new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000).toUTCString();
}
